<template>
  <div class="traceTheSource-reporting">
    <div class="traceTheSource-reporting-header">
      <div class="traceTheSource-reporting-header-left">
        <i class="back" @click="goBack"></i>
        <div class="progress">
          <el-progress
            :text-inside="true"
            :stroke-width="15"
            color="#ff6900"
            :percentage="progress"
          >
          </el-progress>
        </div>
        <div class="history" @click="toHistory">历史溯源</div>
      </div>
      <div class="traceTheSource-reporting-header-title">溯源报告</div>
      <div class="traceTheSource-reporting-header-right">
        <span class="refresh" @click="refresh"
          ><img :src="require('assets/images/refresh-gray.png')" alt=""
        /></span>
        总扣减字符：<span class="char-num">{{
          totalCharacter ? totalCharacter : 0
        }}</span>
      </div>
    </div>
    <div class="traceTheSource-reporting-reportform">
      <div class="traceTheSource-reporting-reportform-table">
        <el-table
          :data="reportPageList"
          style="width: 1218px; margin: 0 auto"
          height="800"
        >
          <el-table-column prop="" label="序号" width="80">
            <template slot-scope="{ row: { status }, $index: index }">
              <div
                :class="[
                  'states',
                  status === 0
                    ? 'orange'
                    : status === 1
                    ? 'blue'
                    : status === 2
                    ? 'green'
                    : 'gray',
                ]"
              >
                {{
                  status === 0
                    ? "未溯源"
                    : status === 1
                    ? "溯源中"
                    : status === 2
                    ? "完成"
                    : "失败"
                }}
              </div>
              <div>{{ index + 1 }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileName"
            label="文件名"
            width="260"
          ></el-table-column>
          <el-table-column width="54"></el-table-column>
          <el-table-column label="数据大小" width="115">
            <template slot-scope="scope">{{ scope.row.fs }}</template>
          </el-table-column>
          <el-table-column label="字符" width="115" align="center">
            <template slot-scope="scope">{{ scope.row.price }}</template>
          </el-table-column>
          <el-table-column label="撤销" width="90" align="center">
            <template slot-scope="{ row: { id, status } }">
              <span class="revoker" @click="revokeSelectTask(id, status)"
                ><img :src="require('assets/images/revoke.png')" alt=""
              /></span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <span class="status">
                <img
                  v-if="scope.row.status == 1"
                  :src="require('assets/images/error.png')"
                  alt=""
                />
                <img
                  v-else
                  :src="require('assets/images/success.png')"
                  alt=""
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column width="24"></el-table-column>
          <el-table-column label="溯源评价" width="150">
            <template slot-scope="{ row: { reportType, level, evaluation } }">
              <div class="evaluate-wrap">
                <div class="nothing" v-if="!evaluation">未溯源</div>
                <div
                  v-if="(reportType == 1 || reportType == 0) && evaluation"
                  class="original"
                >
                  <img :src="getOriginalIcon(level)" alt="" />
                  <span class="txt">严格原创率{{ evaluation }}%</span>
                </div>
                <div v-if="reportType > 1 && evaluation" class="homology">
                  <img
                    v-show="evaluation == '有同源'"
                    :src="require('assets/images/homology-y.png')"
                    alt=""
                  />
                  <img
                    v-show="evaluation == '无同源'"
                    :src="require('assets/images/homology-n.png')"
                    alt=""
                  />
                  <span
                    :class="[
                      'txt',
                      evaluation == '有同源'
                        ? 'is-homology'
                        : evaluation == '无同源'
                        ? 'no-homology'
                        : '',
                    ]"
                  >
                    {{ evaluation }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="在线授权" width="120">
            <template slot-scope="scope">
              <span
                :class="[
                  'authorize',
                  scope.row.originalIds ? 'is-blue' : 'is-gray',
                ]"
                @click="showAuthorize(scope.row.originalIds, scope.row.id)"
              >
                {{ scope.row.originalIds ? "可在线授权" : "无在线授权" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="溯源报告" width="108">
            <template
              slot-scope="{ row: { reportUrl: pdf, fileName, status } }"
            >
              <div class="operate">
                <span
                  class="view"
                  title="查看"
                  v-if="completeStatus(status)"
                  @click="openPdf(pdf)"
                  ><i></i
                ></span>
                <span
                  class="down"
                  title="下载"
                  v-if="completeStatus(status)"
                  @click="download(pdf, fileName)"
                  ><i></i
                ></span>
                <span
                  class="share"
                  title="分享"
                  @click="QrCodeShow(pdf, fileName)"
                  ><i></i
                ></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="traceTheSource-reporting-footer">
      <el-pagination
        background
        layout="prev,pager,next"
        prev-text="上一页"
        next-text="下一页"
        :pager-count="5"
        :page-size="pageSize"
        :page-count="pageCount"
        :current-page="pageNum"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="showTips"
      :modal="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="340px"
    >
      <div class="content">返回到编辑区，当前未溯源文件将被撤销</div>
      <template #footer>
        <div class="footer">
          <span @click="sureBack">确定返回</span>
          <span @click="showTips = false">取消</span>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="showTips2"
      :modal="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="340px"
    >
      <div class="content">{{ tips_text }}</div>
      <template #footer>
        <div class="footer">
          <span @click="showTips2 = false">等一等</span>
          <span @click="showTips2 = false">取消上传</span>
        </div>
      </template>
    </el-dialog>
    <!-- 提示弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogTips" class="tips">
      <div class="content" v-if="curCharacter > totalCharacter">
        <div class="content-text">
          本次溯源将扣减<span>{{ totalCharacter }}</span
          >个字符，字符包现有<span>{{ curCharacter }}</span
          >个字符，该字符将支付给重复字段的原创作者。
        </div>
      </div>
      <div
        class="content"
        v-else
        :class="curCharacter < totalCharacter ? 'active' : ''"
      >
        <i class="content-icon"></i>
        <div class="content-text">
          本次溯源将扣减<span>{{ totalCharacter }}</span
          >个字符，字符包现有<span>{{ curCharacter }}</span
          >个字符，<span>已不足。</span>
        </div>
      </div>
      <div class="footer">
        <div class="footer-btn" @click="sureSubmit">
          {{ curCharacter > totalCharacter ? "确定" : "取消" }}
        </div>
        <div class="footer-btn" v-if="curCharacter > totalCharacter">
          字符包快捷支付
        </div>
        <div
          class="footer-btn"
          v-else
          @click="
            $router.push({ name: 'CopyrightPracticeDetail', params: { id: 2 } })
          "
        >
          购买字符包
        </div>
      </div>
    </el-dialog>

    <!-- 链接二维码弹窗 -->
    <el-dialog
      title="二维码"
      :close-on-click-modal="false"
      :visible.sync="QrCodeVisible"
      @close="handleCloseQrcode"
      class="qrcode"
    >
      <div class="content">
        <div class="notes">分享二维码</div>
        <div class="imgBox">
          <div ref="qrcode_box"></div>
        </div>
        <!-- <el-button type="primary" @click="submitOrder">提交订单</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QrCode from "qrcodejs2";
import {
  checkInterestsNumber,
  batchTraceSource,
  findTraceReportByPage,
  findTraceParseQueueTotalCharacter,
  delTraceSourceTask,
} from "api/traceTheSource";
import { previewUrl } from "api/common";
export default {
  name: "TraceTheSourceReporting",
  data() {
    return {
      reportPageList: [],
      //原创等级
      originalLang: [
        {
          level: "A+",
          icon: require("assets/images/original-a-plus.png"),
        },
        {
          level: "A",
          icon: require("assets/images/original-a.png"),
        },
        {
          level: "B+",
          icon: require("assets/images/original-b-plus.png"),
        },
        {
          level: "B",
          icon: require("assets/images/original-b.png"),
        },
        {
          level: "C",
          icon: require("assets/images/original-c.png"),
        },
      ],
      //当前页
      pageNum: 1,
      //一页大小
      pageSize: 11,
      //总页数
      pageCount: 1,
      //进度
      progress: 0,
      //总数量
      pageTotal: 0,
      //弹框显示
      showTips: false,
      showTips2: false,
      //显示溯源字符提示
      dialogTips: false,
      //弹框提示内容
      tips_text: "",
      //显示字符数量
      curCharacter: 0,
      //总扣减字符
      totalCharacter: 0,
      //计时器id
      timer: null,
      //默认服务器路径
      basePath: "https://fafs.antiplagiarize.com/",
      //批量溯源进行中
      isReporting: false,
      //
      fullPreviewPdf: "",
      // 分享二维码弹窗
      QrCodeVisible: false,
      qr: "",
    };
  },
  methods: {
    //溯源完成状态
    completeStatus(s) {
      return s == 2;
    },
    //去历史溯源
    toHistory() {
      this.$parent.sourceReporting = false;
      this.$parent.historTrace = true;
    },
    // 生成二维码
    crateQrcode(pdf, fileName) {
      const params = {
        fileName: encodeURIComponent(fileName),
        url: encodeURIComponent(pdf),
      };
      this.qr = new QrCode(this.$refs.qrcode_box, {
        text: `http://cloud.antiplagiarize.com/share?fileName=${params.fileName}&url=${params.url}`,
        width: 128,
        height: 128,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
    },
    // 打开分享二维码弹窗
    QrCodeShow(pdf, fileName) {
      this.QrCodeVisible = true;
      this.$nextTick(() => {
        let fileName1 = fileName + "溯源报告.pdf";
        this.crateQrcode(pdf, fileName1);
      });
    },
    // 关闭去除二维码
    handleCloseQrcode() {
      // console.log(1);
      this.$refs.qrcode_box.innerHTML = "";
    },
    goBack() {
      this.showTips = true;
    },
    //确定返回
    sureBack() {
      this.$parent.sourceReporting = false;
      this.$parent.historSource = true;
      delTraceSourceTask().then((res) => {
        if (res.code == 200) {
          clearInterval(this.timer);
          this.$message({
            type: "success",
            message: "撤销成功",
          });
          //清空文件列表
          this.$bus.$emit("clearFileList");
          this.$parent.fileList = [];
        }
      });
    },
    //打开报表pdf
    async openPdf(pdf) {
      if (pdf) {
        this.$store.commit("playLifeLoading", true);
        await this.previewPdf(pdf);
        this.$store.commit("playLifeLoading", false);
        if (this.fullPreviewPdf) {
          window.open(this.fullPreviewPdf);
          this.fullPreviewPdf = "";
        }
      } else {
        this.$message({
          type: "success",
          message: "暂无报告",
        });
      }
    },
    //获取完整编码的预览地址
    async previewPdf(source) {
      const params = {
        url: this.basePath + source,
      };
      const res = await previewUrl(params);
      if (res.code == 200) {
        this.fullPreviewPdf = res.data;
      }
    },
    //下载报表
    download(pdf, name) {
      if (pdf) {
        name = name.substring(0, name.lastIndexOf(".")) + ".pdf";
        const a = document.createElement("a");
        a.href = this.basePath + pdf + "?attname=" + name;
        a.click();
      } else {
        this.$message({
          type: "success",
          message: "暂无报告",
        });
      }
    },
    //刷新-再次查询报表
    refresh() {
      this.$store.commit("playLifeLoading", true);
      this.findTraceReportQueue(() => {
        this.$store.commit("playLifeLoading", false);
      });
    },
    //撤销选中任务
    revokeSelectTask(reportId, status) {
      if (status === 0) {
        if (this.isReporting && this.reportPageList.length === 1) {
          clearInterval(this.timer);
          this.isReporting = false;
        }
        const params = { reportId };
        //撤销
        this.$store.commit("playLifeLoading", true);
        delTraceSourceTask(params).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "撤销成功",
            });
            this.findTraceReportQueue(() => {
              this.$store.commit("playLifeLoading", false);
              // console.log(this.reportPageList);
              if (!this.reportPageList.length) {
                this.$parent.sourceReporting = false;
              }
            });
          }
        });
      }
    },
    currentChange(cur) {
      this.pageNum = cur;
      this.findTraceReportQueue();
    },
    getOriginalIcon(l) {
      if (l) {
        return this.originalLang.filter((i) => i.level === l)[0].icon;
      }
    },
    //查询批量溯源扣减总字符
    checkTotalCharacter() {
      findTraceParseQueueTotalCharacter().then((res) => {
        if (res.code == 200) {
          this.totalCharacter = res.data ? res.data : 0;
          this.getFontNumber(() => {
            this.dialogTips = true;
          });
        }
      });
    },
    /***
     * @param { Function } afterFun 检查字符成功之后的回调
     */
    // 获取字符数量
    async getFontNumber(afterFun) {
      const data = {
        deductNum: this.totalCharacter,
        type: 2,
      };
      const res = await checkInterestsNumber(data);
      if (res.code === 200 || res.code === 7002) {
        this.dialogTips = true;
        this.curCharacter = res.data;
        afterFun();
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    //确定
    sureSubmit() {
      if (this.curCharacter < this.totalCharacter) {
        this.dialogTips = false;
        return;
      }
      this.getReportData();
      this.dialogTips = false;
    },
    //开始批量溯源
    async getReportData() {
      const res = await batchTraceSource();
      if (res.code == 200) {
        this.$bus.$emit("loading1", "溯源中");
        this.$message({
          type: "success",
          message: "开始批量溯源",
        });
        this.isReporting = true;
        let last = Date.now();
        this.timer = setInterval(() => {
          let now = Date.now();
          if (now - last > 1000 * 60 * 5) {
            this.isReporting = false;
            this.$message({
              type: "error",
              message: "请求超时...",
            });
            clearInterval(this.timer);
            this.$bus.$emit("loading", false);
          }
          this.findTraceReportQueue();
          this.$bus.$emit("loading", Number(this.progress));
        }, 1500);
      }
    },
    /**
     * 查询批量溯源队列
     * @param { Function } after 查询成功之后回调
     */
    findTraceReportQueue(after) {
      const params = {
        page: this.pageNum,
        limit: this.pageSize,
      };
      findTraceReportByPage(params)
        .then((res) => {
          if (res.code == 200) {
            this.reportPageList = res.data.queue.data;
            this.pageTotal = res.data.queue.total;
            this.pageCount = Math.ceil(this.pageTotal / this.pageSize);
            this.progress =
              res.data.percentage > 100
                ? 100
                : isNaN(+res.data.percentage)
                ? 0
                : +res.data.percentage;
            this.totalCharacter = res.data.totalPrice;
            if (res.data.percentage == 100 || res.data.percentage > 100) {
              this.isReporting = false;
              clearInterval(this.timer);
              this.$bus.$emit("loading", false);
            }
            after?.();
          }
        })
        .catch((e) => {
          this.isReporting = false;
          this.$message({
            type: "error",
            message: e.name + e.message,
          });
        });
    },
    /***
     * 点击在线授权
     * @param { String } ids 没有ids表示无在线授权
     * @param { Number } id 当前文件id
     */
    showAuthorize(ids, id) {
      if (!ids) return;
      this.$bus.$emit("showAuthorizeList", id);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  top: 50%;
  margin-top: -186px !important;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
  .el-dialog__header {
    padding: 12px 12px 0px;
    .el-dialog__title {
      font-size: $font-size-small;
      font-family: PingFang SC;
      font-weight: 400;
      color: $color-text-gray;
    }
    .el-dialog__headerbtn {
      top: 12px;
      right: 12px;
    }
  }
  .el-dialog__body {
    padding: 40px 25px;
    .content {
      @include flex-center;
      font-size: $font-size-medium-x;
      font-weight: 500;
      color: $color-text-black;
      line-height: 26px;
    }
  }
  .el-dialog__footer {
    padding: 10px 69px 20px 67px;
    .footer {
      @include flex-between;
      span {
        font-size: $font-size-medium;
        font-weight: 500;
        color: $color-text-active;
        cursor: pointer;
      }
    }
  }
}

.traceTheSource-reporting {
  flex: 1;
  //字符提示
  .tips {
    ::v-deep .el-dialog {
      display: flex;
      flex-direction: column;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 340px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        padding: 12px 12px 0px;
        .el-dialog__title {
          font-size: $font-size-small;
          font-family: PingFang SC;
          font-weight: 400;
          color: $color-text-gray;
        }
        .el-dialog__headerbtn {
          top: 12px;
          right: 12px;
        }
      }
      .el-dialog__body {
        padding: 15px 39px;
        flex: 1;
        .content {
          font-size: $font-size-medium-x;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-text-black;
          line-height: 26px;
          display: flex;
          align-items: normal;
          span {
            color: #eb441e;
          }
          .content-icon {
            width: 18px;
            height: 18px;
            flex-shrink: 0;
            @include backgroundGroup("~assets/images/del-error.png");
            transform: translateY(4px);
            margin-right: 9px;
          }
        }
        .active {
          margin-top: 20px;
        }
        .footer {
          display: flex;
          justify-content: space-between;
          margin-top: 33px;
          .footer-btn {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-bg-heightlight;
            cursor: pointer;
          }
        }
      }
    }
  }
  @include flex-center(column);
  align-items: normal;
  height: 100%;
  background-color: #fff;
  &-header {
    @include flex-between;
    height: 45px;
    border-bottom: 1px solid #eef0f4;
    &-left {
      @include flex-start;
      margin-left: 20px;
      .back {
        position: relative;
        width: 20px;
        height: 18px;
        margin-right: 15px;
        cursor: pointer;
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background: url("~assets/images/back-to-editor.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .progress {
        width: 187px;
      }
      .history {
        @include noselect;
        font-size: 12px;
        font-weight: 500;
        color: #ff6900;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    &-title {
      font-size: 12px;
      font-weight: 500;
      color: #ff6900;
    }
    &-right {
      @include noselect;
      @include flex-start;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      margin-right: 21px;
      .refresh {
        img {
          width: 16px;
          height: 14px;
          vertical-align: middle;
        }
        margin-right: 10px;
        cursor: pointer;
      }
      .char-num {
        color: #ff6900;
      }
    }
  }
  &-reportform {
    padding: 0 40px;
    flex: 1;
    &-table {
      margin-top: 21px;
      ::v-deep .el-table::before {
        background-color: transparent;
      }
      ::v-deep .el-table td.el-table__cell {
        overflow: hidden;
        &:first-child {
          @include noselect;
          .cell {
            overflow: visible;
          }
        }
        border-bottom: none;
        .cell {
          @include ellipsis;
          position: relative;
          .states {
            position: absolute;
            left: 30px;
            top: 50%;
            width: 50px;
            height: 18px;
            margin-top: -9px;
            font-size: 12px;
            font-weight: 800;
            text-align: center;
            line-height: 18px;
            color: #fff;
            z-index: 1;
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              display: block;
              width: 100%;
              height: 100%;
              z-index: -1;
            }
          }
          .gray {
            &::before {
              background: url("~assets/images/rhombus-gray.png") no-repeat;
            }
            color: #999;
          }
          .green {
            &::before {
              background: url("~assets/images/rhombus-green.png") no-repeat;
            }
          }
          .orange {
            &::before {
              background: url("~assets/images/rhombus-orange.png") no-repeat;
            }
          }
          .blue {
            &::before {
              background: url("~assets/images/rhombus-blue.png") no-repeat;
            }
          }
          .revoker,
          .status {
            @include noselect;
            cursor: pointer;
          }
          .evaluate-wrap {
            @include noselect;
            font-size: 12px;
            font-weight: 500;
            .nothing {
              color: #999;
            }
            .original,
            .homology {
              @include flex-start;
              .txt {
                margin-left: 5px;
                color: #ff6900;
              }
            }
            .homology {
              .txt {
                &.is-homology {
                  color: #e15240;
                }
                &.no-homology {
                  color: #ff6900;
                }
              }
            }
          }
          .authorize {
            font-size: 12px;
            font-weight: 500;
            text-decoration: underline;
            cursor: pointer;
            &.is-blue {
              color: #ff6900;
            }
            &.is-gray {
              color: #999999;
            }
          }
          .operate {
            @include flex-between;
            span {
              @include flex-start;
              cursor: pointer;
              i {
                position: relative;
                width: 16px;
                height: 16px;
              }
            }
            .view i,
            .down i,
            .share i {
              &::before {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                background-size: 100% 100%;
              }
            }
            .view i::before {
              background: url("~assets/images/report-view-gray.png") no-repeat;
            }
            .view:hover i::before {
              background: url("~assets/images/report-view-blue.png") no-repeat;
            }
            .down i::before {
              background: url("~assets/images/report-down-gray.png") no-repeat;
            }
            .down:hover i::before {
              background: url("~assets/images/report-down-blue.png") no-repeat;
            }
            .share i::before {
              background: url("~assets/images/report-share-gray.png") no-repeat;
            }
            .share:hover i::before {
              background: url("~assets/images/report-share-blue.png") no-repeat;
            }
          }
        }
      }
      ::v-deep .el-table th.el-table__cell.is-leaf {
        border-bottom: none;
      }
    }
  }
  &-footer {
    @include noselect;
    margin: 21px auto;
    ::v-deep .el-pagination {
      button {
        width: 80px;
      }
    }
  }

  .qrcode {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 500px;
      height: 390px;
      background: #ffffff;
      border: 0px solid #818790;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        height: 42px;
        background: #f4f6f7;
        padding: 0;
        line-height: 42px;
        .el-dialog__title {
          margin-left: 15px;
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
        }
        .el-dialog__headerbtn {
          top: $font-size-small;
          right: $font-size-small;
          font-size: $font-size-large;
        }
      }
      .el-dialog__body {
        padding: 65px 20px;
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .notes {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-black;
          }
          .imgBox {
            margin-top: 30px;
          }
        }
      }
    }
  }
}
</style>
